import React, { Component } from "react";

import subjectData from '../../../data/subjects.json';
import Modal from '../../../basic-component/Modal';
import AddSubject from './AddSubject';

import "datatables.net-bs4/css/dataTables.bootstrap4.css"
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
const $ = require('jquery');
require('jszip');
require('pdfmake');
$.DataTable = require('datatables.net-bs4');
// require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-keytable-bs4');
require('datatables.net-responsive-bs4');
class Subjects extends Component {

    state = {
        subjectData: subjectData
    }
    setTableData() {
        let subjectData = this.state.subjectData.map((row) => {
            row['action'] = "<button class='btn btn-info btn-sm'><i class='fa fa-edit'></i></button>&nbsp;<button class='btn btn-danger btn-sm'><i class='fa fa-trash-o'></i></button>";
            return row
        });
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            // lengthChange: false,
            dom: 'lBfrtip',
            data: subjectData,
            columns: [
                { data: 'subjectCode' },
                { data: 'subjectName' },
                { data: 'subjectTeacher' },
                { data: 'bookName' },
            ],
            destroy: true,
            buttons: [
                // {
                //     extend: 'pdf',
                //     text: 'PDF',
                //     className: 'btn btn-success'
                // },
                {
                    extend: 'csv',
                    text: 'CSV',
                    title: "Students Records",
                    className: 'btn btn-success btn-sm'
                },
                {
                    extend: 'print',
                    text: 'Print',
                    title: "<h1 class='text-center'>Student Record</h1>",
                    className: 'btn btn-success btn-sm'
                }
            ]
        });
        table.buttons().container().appendTo(".export-buttons ");
        $('#myTable tbody').on('dblclick', 'tr', function () {
            var data = table.row(this).data();
            console.log(data);
            alert('You clicked on ' + data.name + '\'s row');
        });
    }
    shouldComponentUpdate(prevState, nextState) {
        console.log("prev state", prevState);
        console.log("next State", nextState);
        if (prevState.subjectData !== nextState.subjectData)
            return false
        return true
    }
    componentDidMount() {

        this.setTableData();
        console.log("loded")
    }
    render() {
        let subjects = (
            <div>
                {/* <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>Student</h2> */}

                <div className="card card-design-2">
                    <div className="card-header bg-primary text-white">
                        Subject List by Classes
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-4 col-sm-12">
                                <div className="row">
                                    <div className="mr-1 pd-1"> Select Class</div>
                                    <select className="form-control"><option>Std 1</option></select>
                                </div>
                            </div>
                            <div className="col-lg-8 col-sm-12 text-right export-buttons">
                                {/* <Link to={this.props.match.url + "/Addstudent"} className="btn btn-primary btn-sm"><i className="fa fa-plus"></i> Add Student</Link>&nbsp; */}
                                <button className="btn btn-primary btn-sm" data-toggle="modal" data-target="#myModal" ><i className="fa fa-plus"></i> Add Subject</button>&nbsp;
                                {/* <div className="export-buttons"></div> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className=" table-responsive" style={{ padding: "10px" }}>
                                <table id="myTable" className="table table-hover table-bordered dt-responsive nowrap" width="100%" ref={el => this.el = el} >
                                    <thead>
                                        <tr>
                                            <th>Subject Code</th>
                                            <th>Subject Name</th>
                                            <th>Teacher</th>
                                            <th>Book Name</th>

                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
        return (
            <div>
                <Modal header="Add Subject" modalWidth="modal-lg" modalId="myModal" action="Add Subject"><AddSubject /></Modal>
                {subjects}
            </div>
        );

    }
}
export default Subjects;